import React from 'react'
import { Stack, Typography } from '@mui/material';

export default function FieldLabel({ icon, children }) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{ color: "text.secondary", mb: 0.25 }}
    >
      {icon}
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          fontSize: 11,
        }}
      >
        {children}
      </Typography>
    </Stack>
  );
}
